module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAFRKKwcAAAABGdBTUEAALGPC/xhBQAAAThJREFUKBWNkrtKQ0EQhnfFS0CLgGXSKCR5C7GzVwQrg521pInis5g3sPUFtBO1sxK8VNoYTgjEwvX7N7M5JyQnOPDtzPyzs2f37DqHhRBONZxD8DFDVRBUVqkLQ/iE1yQexIBBU0/waybc5L2mLJnPHS1HeUaE0IFS0xIr8AgdyGAHZNtxpLVe2h7Cg3a1xcy9OHt6GHnvr5bRXqb1PKO5mo7xZvKX+aH5Spqwa8I+fgCXoI0X/qqyWbvQf3hacIpa7GHC82yzKRRb8LFglbLSO4WGDqG7HX+q9DNzC3XUQy0wfjrO3RJvQBtk39CElsU4dwyac6cEC+nJpW1mBL8pwY+MJKk2SAm+q5vUf0+m1Yu2WkyIPawXtEyCdlHFnYEuUHYNPfiBeSb9nrfUnxRZpAabE+GfwR/HWTuuKTasqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ly.png
// module id = NsI9
// module chunks = 1